import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import type { UserMenuOption } from '@typings/plugin-runtime.ts';
import { Icon } from '@ui/icons/Icon.tsx';

import { useCSSColors } from '../../../src/hooks/useCSSColors.ts';

const MenuOptionButton = styled.button`
  width: 100%;
  height: 56px;
  box-shadow: inset 0px -1px 0px #ebebeb;
  background: none;
  display: flex;
  align-items: center;
  padding: 12px;
  outline: none;
  border: none;
  cursor: pointer;
  color: var(--color-primaryText);

  &:hover {
    background-color: var(--color-widgetText-10);
  }

  .menuLabel {
    font-size: 16px;
    line-height: 19px;
    margin-inline-start: 8px;
  }

  &:focus-visible {
    outline: var(--focus-outline);
    outline-offset: -3px;
    border-radius: 4px;
  }
`;

type MenuSelectionProps = {
  menuOptions: UserMenuOption[];
  isMobile: boolean;
  hideMenu: () => void;
};

const handleMenuOptionClick = (onClickOption: UserMenuOption['onClick'], hideMenu: () => void) => {
  void onClickOption();
  hideMenu();
};

const MenuSelection = ({ menuOptions, isMobile, hideMenu }: MenuSelectionProps) => {
  const colors = useCSSColors() as Record<string, string>;

  return (
    <>
      {menuOptions.map(option => (
        <MenuOptionButton
          key={option.id ?? option.label}
          onClick={() => handleMenuOptionClick(option.onClick, hideMenu)}
          className={`menuOption${isMobile ? '-mobile' : ''}`}
          data-testid="MenuOption"
          lang={option.lang}
        >
          <Icon name={option.iconId} cdn width={32} height={32} fillColor={colors.primaryText} />
          <div className="menuLabel">{option.label}</div>
        </MenuOptionButton>
      ))}
    </>
  );
};

MenuSelection.propTypes = { menuOptions: PropTypes.array.isRequired };

export default MenuSelection;
